import * as React from "react";
import * as ReactDOM from "react-dom";

export interface TitleProps {
    pageTitle?: string;
    siteTitle: string;
}

export class Title extends React.Component<TitleProps, any> {
    static defaultProps = {
        pageTitle: null,
        siteTitle: "Onlinekarte",
    };

    titleEl: any;

    constructor(props: TitleProps) {
        super(props);
        this.titleEl = document.getElementsByTagName("title")[0];
    }

    render() {
        let fullTitle;
        if (this.props.pageTitle) {
            fullTitle = this.props.siteTitle + " - " + this.props.pageTitle;
        } else {
            fullTitle = this.props.siteTitle;
        }

        return ReactDOM.createPortal(
            fullTitle || "",
            this.titleEl
        );
    }
}
